// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EntityTable from 'app/components/CRUD/EntityTable';
import BusinessIcon from '@mui/icons-material/Business';
import moment from 'moment';

import {
  CONFIG_ROUTES,
  CONFIG_URLS,
} from 'app/configuration/configuration-api';

// Both issuer names are shown as their own columns, so this table needs no
// language switch of its own.
const FareMediaIssuersTable: React.FC = () => {
  return (
    <EntityTable
      // ============ PAGE CONFIGURATION ============
      pageTitle="FareMediaIssuers"
      pageIcon={BusinessIcon}
      addButtonLabel="AddNewFareMediaIssuer"

      // ============ NAVIGATION URLs ============
      addPageUrl={`${CONFIG_ROUTES.fareMediaIssuers}/new`}
      viewPageUrl={`${CONFIG_ROUTES.fareMediaIssuers}/:id`}
      editPageUrl={`${CONFIG_ROUTES.fareMediaIssuers}/:id/edit?came_from=all`}

      // ============ API CONFIGURATION ============
      getApiUrl={CONFIG_URLS.fareMediaIssuers}
      getApiMethod="GET"

      // Hard DELETE — the table has no soft-delete column. The API refuses with
      // a translated 409 when the issuer still has organisation assignments
      // (ON DELETE RESTRICT), and EntityTable shows that message in a toast.
      deleteApiUrl={CONFIG_URLS.fareMediaIssuerById}
      deleteApiMethod="DELETE"

      // ============ RESPONSE CONFIGURATION ============
      responseDataPath="data.data.fareMediaIssuers"
      responsePaginationPath="data.data.pagination"

      // ============ TABLE CONFIGURATION ============
      idField="id"
      columns={[
        {
          field: 'en_issuer_name',
          headerKey: 'NameEnglish',
          align: 'center',
          sortable: true,
          sortField: 'fmi.en_issuer_name',
        },
        {
          field: 'ar_issuer_name',
          headerKey: 'NameArabic',
          align: 'center',
          sortable: true,
          sortField: 'fmi.ar_issuer_name',
        },
        {
          field: 'phone',
          headerKey: 'Phone',
          align: 'center',
          render: value => value || '-',
          sortable: true,
          sortField: 'fmi.phone',
        },
        {
          field: 'email',
          headerKey: 'Email',
          align: 'center',
          render: value => value || '-',
          sortable: true,
          sortField: 'fmi.email',
        },
        {
          field: 'organisations_count',
          headerKey: 'AssignedOrganisations',
          align: 'center',
          render: value => (value === undefined || value === null ? '-' : value),
        },
        {
          field: 'created_at',
          headerKey: 'CreatedAt',
          align: 'center',
          render: value => (value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '-'),
          sortable: true,
          sortField: 'fmi.created_at',
        },
      ]}

      // ============ SEARCH CONFIGURATION ============
      searchQueryParam="search"
      searchPlaceholder="SearchFareMediaIssuerPlaceholder"
      searchInputWidth="350px"

      // ============ FILTER CONFIGURATION ============
      filterFields={[]}

      // ============ PERMISSIONS ============
      subsystemName="FareMediaIssuers"
      permissionSystem="masterConfig"

      // ============ ACTIONS ============
      showAddButton={true}
      showActions={true}
      showEdit={true}
      showDelete={true}
      deleteConfirmationMessage="AreYouSureDeleteFareMediaIssuer"
    />
  );
};

export default FareMediaIssuersTable;
